import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Transition as _Transition, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "nav-items" }
const _hoisted_3 = { class: "submenu-header" }
const _hoisted_4 = { class: "submenu-list" }
const _hoisted_5 = { class: "user-info" }
const _hoisted_6 = { class: "username dropdown-link" }
const _hoisted_7 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_8 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_9 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_10 = {
  key: 3,
  class: "tab-content"
}
const _hoisted_11 = {
  key: 4,
  class: "tab-content"
}
const _hoisted_12 = {
  key: 1,
  class: "not-logged-in"
}
const _hoisted_13 = {
  key: 5,
  class: "tab-content"
}
const _hoisted_14 = {
  key: 6,
  class: "tab-content"
}
const _hoisted_15 = {
  key: 7,
  class: "tab-content"
}
const _hoisted_16 = {
  key: 8,
  class: "tab-content"
}
const _hoisted_17 = {
  key: 9,
  class: "tab-content"
}

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ArrowDown, SwitchButton, Star, EditPen, Document, Close, ArrowRightBold, House, User, ChatLineRound, SetUp, ArrowLeft, ChatDotSquare, Bell, BellFilled, Delete, ChatDotRound, MagicStick } from '@element-plus/icons-vue';
import PostListView from '@/user/views/post/PostListView.vue';
import PostDetailView from '@/user/views/post/PostDetailView.vue';
import UserFavoritesView from '@/user/views/post/UserFavoritesView.vue';
import UserPostsView from '@/user/views/post/UserPostsView.vue';
import PostCreateView from '@/user/views/post/PostCreateView.vue'; // 导入创建帖子组件
import AvatarUploadModal from '@/user/views/user/AvatarUploadModal.vue'; // 导入头像上传弹窗组件
import ProfileView from '@/user/views/user/ProfileView.vue'; // 导入个人资料组件
import OtherUserProfileModal from '@/user/views/user/OtherUserProfileModal.vue'; // 导入其他用户资料模态框组件
import ChatView from '@/user/views/message/ChatView.vue'; // 导入聊天组件
import AiView from '@/user/views/aichat/AiView.vue'; // 导入AI问答组件
import AnnouncementCenterView from '@/user/views/message/AnnouncementCenterView.vue'; // 导入公告中心组件
import NotificationCenterView from '@/user/views/message/NotificationCenterView.vue'; // 导入通知中心组件
import DashboardView from '@/user/views/dashboard/DashboardView.vue'; // 导入首页组件
import { startPollingUnreadCounts, stopPollingUnreadCounts, unreadAnnouncements, unreadNotifications, initWebSocketNotifications } from '@/user/services/notificationService';
import { notificationApi } from '@/user/api/notification';
import { userAnnouncementApi } from '@/user/api/announcement';
import { getUnreadMessageCount } from '@/user/api/interaction'; // 导入获取未读消息数的API


export default /*@__PURE__*/_defineComponent({
  __name: 'UserHomeView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();

const activeTab = ref('dashboard'); // 默认显示首页
const questionInput = ref(''); 
const postIdFromRoute = ref<number | null>(null);
const showSubmenu = ref(false);
const showCreatePostDialog = ref(false); // 控制创建帖子弹窗显示
const showAvatarUploadModal = ref(false); // 控制头像上传弹窗显示
const showOtherUserProfileModal = ref(false); // 控制其他用户资料模态框显示
const targetUserId = ref<number | null>(null); // 目标用户ID，用于消息页面
const showMessageMenu = ref(false); // 控制消息下拉菜单显示
const unreadChatMessages = ref(0); // 新增：存储未读私信数

// 计算未读总数
const totalUnread = computed(() => {
  return unreadAnnouncements.value + unreadNotifications.value + unreadChatMessages.value;
});

// 使用计算属性来响应store的变化
const computedIsLoggedIn = computed(() => store.getters.isAuthenticated);
const computedUserInfo = computed(() => store.state.userInfo);

// 监听登录状态变化，开始或停止轮询
watch(computedIsLoggedIn, (isLoggedIn) => {
  if (isLoggedIn) {
    // 初始化WebSocket通知处理器，确保能接收公告和通知消息
    initWebSocketNotifications();
    startPollingUnreadCounts(30000); // 每30秒轮询一次
  } else {
    stopPollingUnreadCounts();
    // 登出时重置未读数
    unreadAnnouncements.value = 0;
    unreadNotifications.value = 0;
  }
}, { immediate: true });

// 控制二级菜单的显示与隐藏
const toggleSubmenu = (e: Event) => {
  e.stopPropagation(); // 阻止事件冒泡
  showSubmenu.value = !showSubmenu.value;
  
  // 如果展开菜单且用户已登录，则获取未读私信数
  if (showSubmenu.value && computedIsLoggedIn.value) {
    fetchUnreadChatCount();
  }
};

// 专门用于帖子广场的点击事件
const goToSquare = () => {
  selectTab('square');
  // 如果菜单是隐藏的，点击帖子广场时显示菜单
  if (!showSubmenu.value) {
    showSubmenu.value = true;
    // 如果用户已登录，则获取未读私信数
    if (computedIsLoggedIn.value) {
      fetchUnreadChatCount();
    }
  }
};

// 点击页面其他地方时隐藏菜单
const handleClickOutside = (e: Event) => {
  const target = e.target as HTMLElement;
  const navItem = target.closest('.nav-item');
  const submenu = target.closest('.sidebar-submenu');
  const messageDropdown = target.closest('.message-dropdown');
  
  // 如果点击的不是导航项也不是二级菜单，也不是消息下拉菜单，则隐藏所有菜单
  if (!navItem && !submenu && !messageDropdown) {
    showSubmenu.value = false;
    showMessageMenu.value = false;
  }
};

// 选择标签页
const selectTab = (tab: string) => {
  activeTab.value = tab;
  
  // 根据标签页更新路由，但不包括帖子详情页，因为它由路由参数控制
  if(tab !== 'postDetail') {
    let path = '/';
    if(tab === 'dashboard') path = '/';  // 首页对应根路径
    else if(tab === 'square') path = '/post';  // 帖子广场对应 /post 路由
    else if(tab === 'ai') path = '/ai';
    else if(tab === 'profile') path = '/profile';
    else if(tab === 'favorites') path = '/user/favorites';
    else if(tab === 'userPosts') path = '/user/posts';
    else if(tab === 'friends') path = '/user/friends'; // 添加好友路由
    else if(tab === 'chat') path = '/user/chat'; // 添加聊天路由
    else if(tab === 'announcements') path = '/announcements'; // 添加公告路由
    else if(tab === 'notifications') path = '/notifications'; // 添加通知路由
    else if(tab === 'message') path = `/user/message/${targetUserId.value}`; // 消息路由
    
    if(route.path !== path) {
      router.push(path);
    }
  }
  
  // 切换标签页时隐藏二级菜单
  showSubmenu.value = false;
  showMessageMenu.value = false;
};

// 以下是导航到二级菜单项的方法（仅占位，不实现具体逻辑）
const goToUserCollection = () => {
  // 切换到用户收藏内容显示
  activeTab.value = 'favorites';
  showSubmenu.value = false;
};

const goToCreatePost = () => {
  // 显示创建帖子弹窗
  console.log("显示创建帖子弹窗");
  showCreatePostDialog.value = true;
  showSubmenu.value = false;
};

const goToPersonalPosts = () => {
  // 切换到个人帖子内容显示
  activeTab.value = 'userPosts';
  showSubmenu.value = false;
};

// 添加公告中心导航方法
const goToAnnouncements = () => {
  activeTab.value = 'announcements';
  showSubmenu.value = false;
  showMessageMenu.value = false;
};

// 添加通知中心导航方法
const goToNotifications = () => {
  activeTab.value = 'notifications';
  showSubmenu.value = false;
  showMessageMenu.value = false;
};

// 添加聊天功能相关方法
const goToChat = async () => {
  // 在跳转之前获取最新的未读消息数
  await fetchUnreadChatCount();
  activeTab.value = 'chat';
  showSubmenu.value = false;
};

// 返回帖子广场
const goBackToSquare = () => {
  activeTab.value = 'square';
  postIdFromRoute.value = null; // 清除帖子ID
  router.push('/post'); // 跳转到帖子列表页，实际上还是在 UserHomeView 中
};

// 跳转到管理后台登录页
const goToAdminLogin = () => {
  router.push({ name: 'admin-login' });
};

// 跳转到登录页
const goToLogin = () => {
  router.push({ name: 'login' });
};

// 处理消息下拉菜单命令
const handleMessageCommand = (command: string) => {
  if(command === 'announcements') {
    activeTab.value = 'announcements';
    router.push('/announcements');
  } else if(command === 'notifications') {
    activeTab.value = 'notifications';
    router.push('/notifications');
  }
  showMessageMenu.value = false;
};

// 处理下拉菜单命令
const handleCommand = async (command: string) => {
  if (command === 'logout') {
    try {
      await ElMessageBox.confirm(
        '确定要退出登录吗？',
        '确认退出',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      );

      // 调用store中的logout action
      const logoutSuccess = await store.dispatch('logout');
      
      if (logoutSuccess) {
        ElMessage.success('已退出登录');
        // 跳转到登录页面
        router.push({ name: 'login' });
      } else {
        ElMessage.error('退出登录失败');
      }
    } catch (error) {
      // 用户取消了操作
      console.log('用户取消退出登录');
    }
  } else if (command === 'announcements') {
    // 跳转到系统公告页面
    router.push({ name: 'announcements' });
    // 关闭下拉菜单
    activeTab.value = 'announcements';
  } else if (command === 'notifications') {
    // 跳转到互动消息页面
    router.push({ name: 'notifications' });
    // 关闭下拉菜单
    activeTab.value = 'notifications';
  } else if (command === 'markAllAsRead') {
    try {
      // 标记所有公告为已读
      if (unreadAnnouncements.value > 0) {
        // 获取所有未读公告并批量标记
        const response = await userAnnouncementApi.getAnnouncementList(1, 9999);
        if (response.data && response.data.records) {
          const unreadAnnouncementsList = response.data.records.filter(ann => ann.isRead === 0);
          const unreadIds = unreadAnnouncementsList.map(ann => ann.id);
          if (unreadIds.length > 0) {
            await userAnnouncementApi.batchMarkAsRead(unreadIds);
          }
        }
      }
      // 标记所有通知为已读
      if (unreadNotifications.value > 0) {
        await notificationApi.markAllNotificationsAsRead();
      }
      ElMessage.success('已标记全部为已读');
      // 刷新未读消息计数
      startPollingUnreadCounts(30000);
    } catch (error) {
      console.error('标记全部已读失败:', error);
      ElMessage.error('标记全部已读失败');
    }
  } else if (command === 'clearAllNotifications') {
    try {
      await ElMessageBox.confirm(
        '此操作将永久删除所有消息，是否继续？',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      );

      // 清除所有通知
      await notificationApi.clearAllNotifications();
      ElMessage.success('已清除全部消息');
      // 刷新未读消息计数
      startPollingUnreadCounts(30000);
    } catch (error) {
      if (error !== 'cancel') {
        console.error('清除消息失败:', error);
        ElMessage.error('清除消息失败');
      }
    }
  }
};

// 添加处理显示帖子详情的方法
const showPostDetail = (postId: number) => {
  postIdFromRoute.value = postId;
  activeTab.value = 'postDetail';
  // 现在启用路由跳转，以便URL反映当前状态
  router.push(`/post/${postId}`);
};

// 监听路由变化，统一处理所有路径情况
watch(
  () => route.path,
  (newPath) => {
    if(newPath === '/' || newPath === '/post') {
      if(newPath === '/') {
        activeTab.value = 'dashboard';
      } else {
        activeTab.value = 'square';
      }
      // 如果路由切换到了其他页面，隐藏二级菜单
      showSubmenu.value = false;
    } else if(newPath === '/ai') {
      activeTab.value = 'ai';
      showSubmenu.value = false;
    } else if(newPath === '/profile') { // 添加个人资料路由处理
      activeTab.value = 'profile';
      showSubmenu.value = false;
    } else if(newPath.startsWith('/profile/')) { // 处理 /profile/:userId 路由，显示其他用户资料
      const pathParts = newPath.split('/');
      const userId = parseInt(pathParts[pathParts.length - 1]);
      if(!isNaN(userId)) {
        targetUserId.value = userId;
        showOtherUserProfileModal.value = true;
        showSubmenu.value = false;
      }
    } else if(newPath === '/user/chat') {
      activeTab.value = 'chat';
      showSubmenu.value = false;
    } else if(newPath === '/announcements') { // 添加公告路由处理
      activeTab.value = 'announcements';
      showSubmenu.value = false;
    } else if(newPath === '/notifications') { // 添加通知路由处理
      activeTab.value = 'notifications';
      showSubmenu.value = false;
    } else if(newPath.startsWith('/user/message/')) { // 添加消息路由处理
      // 提取用户ID
      const pathParts = newPath.split('/user/message/');
      const userId = parseInt(pathParts[1]);
      if(!isNaN(userId)) {
        targetUserId.value = userId;
        activeTab.value = 'message';
        showSubmenu.value = false;
      }
    } else if(newPath.match(/^\/post\/\d+$/)) {
      // 匹配 /post/:id 路径，提取ID并显示详情页
      const postId = parseInt(newPath.split('/')[2]);
      if(!isNaN(postId)) {
        postIdFromRoute.value = postId;
        activeTab.value = 'postDetail';
        showSubmenu.value = false;
      }
    }
  },
  { immediate: true }
);

// 监听路由参数变化，当postId参数变化时更新
watch(
  () => route.params,
  (newParams) => {
    // 检查是否是消息路由参数变化
    if(newParams.userId) {
      const userId = parseInt(newParams.userId as string);
      if(!isNaN(userId)) {
        targetUserId.value = userId;
        activeTab.value = 'message';
        showSubmenu.value = false;
      }
    } else if(newParams.postId) {
      const postId = Number(newParams.postId);
      if(postId) {
        postIdFromRoute.value = postId;
        activeTab.value = 'postDetail';
        showSubmenu.value = false;
      } else if(activeTab.value === 'postDetail') {
        // 如果URL中不再有postId参数，返回广场
        activeTab.value = 'square';
      }
    }
  },
  { immediate: true }
);

// 处理关闭创建帖子弹窗
const handleCloseCreatePostDialog = () => {
  showCreatePostDialog.value = false;
};

// 处理帖子创建成功事件
const onPostCreated = () => {
  showCreatePostDialog.value = false;
  ElMessage.success('帖子发布成功！');
  // 可以刷新当前页面内容，或者跳转到相应页面
  if (activeTab.value !== 'square') {
    selectTab('square');
  }
  // 刷新帖子列表
  // 这里可以触发列表刷新逻辑
};

// 打开头像上传弹窗
const openAvatarUploadModal = () => {
  showAvatarUploadModal.value = true;
};

// 生成带时间戳的头像URL以避免缓存问题
const getAvatarSrc = (avatarUrl: string | undefined) => {
  if (!avatarUrl) {
    // 使用默认头像
    return 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png';
  }
  
  // 检查是否是完整的URL（包含协议）
  let fullUrl = '';
  if (avatarUrl.startsWith('http')) {
    fullUrl = avatarUrl;
  } else if (avatarUrl.startsWith('/')) {
    // 如果是绝对路径，拼接基础URL
    fullUrl = `${window.location.origin}${avatarUrl}`;
  } else {
    // 如果是相对路径，拼接基础URL
    fullUrl = `${window.location.origin}/${avatarUrl}`;
  }
  
  // 添加时间戳参数以避免缓存
  const url = new URL(fullUrl);
  url.searchParams.set('t', Date.now().toString());
  return url.toString();
};

// 处理头像上传成功事件
const handleAvatarUploaded = () => {
  // 头像已在AvatarUploadModal中更新到store，此处无需额外操作
  // computedUserInfo会自动响应store中的变化
  ElMessage.success('头像更新成功！');
  showAvatarUploadModal.value = false;
};

// 处理头像上传弹窗关闭事件
const handleAvatarModalClose = () => {
  showAvatarUploadModal.value = false;
};

// 处理其他用户资料模态框关闭事件
const handleOtherUserProfileClose = () => {
  showOtherUserProfileModal.value = false;
  // 不再跳转到首页，保持在当前页面
};

// 处理头像点击事件
const handleAvatarClick = () => {
  if (computedIsLoggedIn.value) {
    openAvatarUploadModal();
  } else {
    // 如果未登录，跳转到登录页面
    goToLogin();
  }
};

// 添加获取未读私信数的方法
const fetchUnreadChatCount = async () => {
  try {
    const response = await getUnreadMessageCount();
    if (response.code === 1) {
      unreadChatMessages.value = response.data || 0;
    } else {
      console.error('获取未读消息数失败:', response.msg);
      unreadChatMessages.value = 0;
    }
  } catch (error) {
    console.error('获取未读消息数异常:', error);
    unreadChatMessages.value = 0;
  }
};

onMounted(() => {
  // 初始化WebSocket通知处理器，确保能接收公告和通知消息
  if (computedIsLoggedIn.value) {
    initWebSocketNotifications();
  }
  document.addEventListener('click', handleClickOutside);
});

// 组件销毁前移除事件监听器
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
  // 组件卸载时停止轮询
  stopPollingUnreadCounts();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { class: "header-nav" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "logo",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (selectTab('dashboard')))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "crochet-icon" }, "_hooks", -1),
                _createElementVNode("span", { class: "logo-text" }, "钩织乐园", -1)
              ]))]),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item", { active: activeTab.value === 'square' }]),
                onClick: goToSquare
              }, [
                _createVNode(_component_el_icon, { class: "nav-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChatDotRound))
                  ]),
                  _: 1
                }),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "帖子广场", -1))
              ], 2),
              _createVNode(_Transition, { name: "slide-from-left" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    class: "sidebar-submenu",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "submenu-title" }, "功能菜单", -1)),
                      _createVNode(_component_el_button, {
                        class: "close-btn",
                        link: true,
                        size: "small",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showSubmenu.value = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Close))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("ul", _hoisted_4, [
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (selectTab('dashboard')))
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(House))
                          ]),
                          _: 1
                        }),
                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "首页", -1))
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (selectTab('square')))
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ChatDotRound))
                          ]),
                          _: 1
                        }),
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "帖子广场", -1))
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: goToUserCollection
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Star))
                          ]),
                          _: 1
                        }),
                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "我的收藏", -1))
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: goToCreatePost
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(EditPen))
                          ]),
                          _: 1
                        }),
                        _cache[18] || (_cache[18] = _createElementVNode("span", null, "发布帖子", -1))
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: goToPersonalPosts
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Document))
                          ]),
                          _: 1
                        }),
                        _cache[19] || (_cache[19] = _createElementVNode("span", null, "我的帖子", -1))
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: goToChat
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ChatLineRound))
                          ]),
                          _: 1
                        }),
                        _cache[20] || (_cache[20] = _createElementVNode("span", null, "私信聊天", -1)),
                        (unreadChatMessages.value > 0)
                          ? (_openBlock(), _createBlock(_component_el_badge, {
                              key: 0,
                              value: unreadChatMessages.value,
                              class: "submenu-icon",
                              type: "danger"
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (selectTab('ai')))
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(MagicStick))
                          ]),
                          _: 1
                        }),
                        _cache[21] || (_cache[21] = _createElementVNode("span", null, "AI问答", -1))
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (selectTab('profile')))
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(User))
                          ]),
                          _: 1
                        }),
                        _cache[22] || (_cache[22] = _createElementVNode("span", null, "个人中心", -1))
                      ]),
                      _createElementVNode("li", {
                        class: "submenu-item",
                        onClick: goToAdminLogin
                      }, [
                        _createVNode(_component_el_icon, { class: "submenu-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SetUp))
                          ]),
                          _: 1
                        }),
                        _cache[23] || (_cache[23] = _createElementVNode("span", null, "管理后台", -1))
                      ])
                    ])
                  ], 512), [
                    [_vShow, showSubmenu.value]
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item", { active: activeTab.value === 'ai' }]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (selectTab('ai')))
              }, [
                _createVNode(_component_el_icon, { class: "nav-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MagicStick))
                  ]),
                  _: 1
                }),
                _cache[24] || (_cache[24] = _createElementVNode("span", null, "AI问答", -1))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item", { active: activeTab.value === 'profile' }]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (selectTab('profile')))
              }, [
                _createVNode(_component_el_icon, { class: "nav-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(User))
                  ]),
                  _: 1
                }),
                _cache[25] || (_cache[25] = _createElementVNode("span", null, "个人中心", -1))
              ], 2),
              _createElementVNode("div", {
                class: "nav-item",
                onClick: goToAdminLogin
              }, [
                _createVNode(_component_el_icon, { class: "nav-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SetUp))
                  ]),
                  _: 1
                }),
                _cache[26] || (_cache[26] = _createElementVNode("span", null, "管理后台", -1))
              ]),
              (activeTab.value === 'postDetail')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "nav-item back-btn",
                    onClick: goBackToSquare
                  }, [
                    _createVNode(_component_el_icon, { class: "nav-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowLeft))
                      ]),
                      _: 1
                    }),
                    _cache[27] || (_cache[27] = _createElementVNode("span", null, "返回", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_avatar, {
                  size: 40,
                  src: getAvatarSrc(computedUserInfo.value?.avatar),
                  class: _normalizeClass(["user-avatar", { 'no-click': !computedIsLoggedIn.value }]),
                  onClick: handleAvatarClick
                }, null, 8, ["src", "class"]),
                (computedIsLoggedIn.value)
                  ? (_openBlock(), _createBlock(_component_el_dropdown, {
                      key: 0,
                      onCommand: handleCommand
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, { command: "announcements" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ChatDotSquare))
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" 系统公告 (" + _toDisplayString(_unref(unreadAnnouncements)) + ") ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, { command: "notifications" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Bell))
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" 互动消息 (" + _toDisplayString(_unref(unreadNotifications)) + ") ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              command: "logout",
                              divided: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(SwitchButton))
                                  ]),
                                  _: 1
                                }),
                                _cache[28] || (_cache[28] = _createTextVNode(" 退出登录 ", -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, [
                          _createTextVNode(_toDisplayString(computedUserInfo.value?.name || computedUserInfo.value?.username) + " ", 1),
                          _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowDown))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "username login-prompt",
                      onClick: goToLogin
                    }, "请登录"))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(AvatarUploadModal, {
          modelValue: showAvatarUploadModal.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showAvatarUploadModal).value = $event)),
          currentAvatar: computedUserInfo.value?.avatar,
          onUploaded: handleAvatarUploaded,
          onClose: handleAvatarModalClose
        }, null, 8, ["modelValue", "currentAvatar"]),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "sidebar-trigger-left fixed-trigger",
              onClick: toggleSubmenu
            }, [
              (!showSubmenu.value)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowRightBold))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Close))
                    ]),
                    _: 1
                  }))
            ]),
            (activeTab.value === 'dashboard')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(DashboardView)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'square')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(PostListView, {
                    onShowPostDetail: showPostDetail,
                    onNeedLogin: goToLogin
                  })
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'favorites')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(UserFavoritesView, {
                    onShowPostDetail: showPostDetail,
                    onNeedLogin: goToLogin
                  })
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'ai')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(AiView)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'profile')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (computedIsLoggedIn.value)
                    ? (_openBlock(), _createBlock(ProfileView, { key: 0 }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[30] || (_cache[30] = _createElementVNode("h3", null, "🌸 欢迎来到钩织乐园", -1)),
                        _cache[31] || (_cache[31] = _createElementVNode("p", null, "登录后即可记录您的钩织历程，与其他爱好者交流心得", -1)),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: goToLogin,
                          round: ""
                        }, {
                          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                            _createTextVNode("立即登录", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createVNode(OtherUserProfileModal, {
              modelValue: showOtherUserProfileModal.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showOtherUserProfileModal).value = $event)),
              userId: targetUserId.value!,
              onClose: handleOtherUserProfileClose
            }, null, 8, ["modelValue", "userId"]),
            (activeTab.value === 'userPosts')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(UserPostsView, {
                    onShowPostDetail: showPostDetail,
                    onNeedLogin: goToLogin
                  })
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'chat')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(ChatView)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'announcements')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(AnnouncementCenterView)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'notifications')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(NotificationCenterView)
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'postDetail')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(PostDetailView, {
                    postId: postIdFromRoute.value!
                  }, null, 8, ["postId"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: showCreatePostDialog.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showCreatePostDialog).value = $event)),
      title: "发布帖子",
      width: "60%",
      "before-close": handleCloseCreatePostDialog,
      "close-on-click-modal": false,
      "destroy-on-close": "",
      class: "create-post-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(PostCreateView, {
          onPostCreated: onPostCreated,
          onCancel: handleCloseCreatePostDialog
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})